<div class="container">
  <ul class="list-group mt-4">
    <li
      *ngFor="let note of notes"
      class="list-group-item list-group-item-action flex-column align-items-start"
    >
      <div class="d-flex w-100 justify-content-between">
        <h5 class="mb-1">#</h5>
        <small>{{
          note.creationTime | momentPipe : "DD-MM-YYYY, hh:mm a"
        }}</small>
      </div>
      <p class="mb-1">{{ note.content }}</p>
      <small>{{ note.creator }}</small>
    </li>
  </ul>
</div>
